import { render, staticRenderFns } from "./StickyNavigation.vue?vue&type=template&id=3e85db10&scoped=true&"
import script from "./StickyNavigation.vue?vue&type=script&lang=js&"
export * from "./StickyNavigation.vue?vue&type=script&lang=js&"
import style0 from "./StickyNavigation.vue?vue&type=style&index=0&id=3e85db10&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e85db10",
  null
  
)

export default component.exports